'use client';

import { parseAsInteger, useQueryState } from 'nuqs';
import { useTranslation } from 'react-i18next';

import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.js';
import { FlexibleContentProps } from '@sola/schema/lib/schema.js';
import { trackClick } from '@sola/tracking/components/datalayer.js';

export type StepperCompactProps = {
  items?: Array<FlexibleContentProps>;
};

export const StepperCompact: React.FC<StepperCompactProps> = ({ items }) => {
  const [activeIndex, setActiveIndex] = useQueryState(
    'step',
    parseAsInteger.withDefault(0),
  );
  const { t } = useTranslation('help-me');

  return (
    items &&
    items.length > 0 && (
      <div className="StepperTabbed__list--mobile flex flex-row align-center justify-between flex-1 mb-comfy-xs mt-comfy-sm">
        <button
          type="button"
          onClick={() => {
            setActiveIndex(Math.max(activeIndex - 1, 0));
            trackClick('Skip', undefined, 'Stepper__mobile');
          }}
        >
          {activeIndex > 0 && (
            <ArkIcon iconName="arrow-left" aria-label={t('pagination.back')} />
          )}
        </button>

        <div className="flex flex-col items-center">
          <span className="label-potent label-lg">
            {t('pagination.select', {
              attribute: `${items[activeIndex].title}`,
            })}
          </span>
          <span className="label-moderate label-sm">
            {t('pagination.stepOfSteps', {
              step: `${activeIndex + 1}`,
              total: `${items.length}`,
            })}
          </span>
        </div>
        <button
          type="button"
          onClick={() => {
            setActiveIndex(Math.min(activeIndex + 1, items.length));
            trackClick('Skip', undefined, 'Stepper__mobile');
          }}
        >
          {activeIndex < 4 && (
            <ArkIcon iconName="arrow-right" aria-label={t('pagination.next')} />
          )}
        </button>
      </div>
    )
  );
};
